import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class FormValidators {
  /**
   * Validator for integer input fields.
   *
   */
  public static number(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const error: ValidationErrors = { integer: true };
      const value = control.value.replace(',', '.');

      if (!value) {
        return error;
      }

      let trimmedValue = value.replace(/\s/g, '');

      if (value && !/^\d+([\.\,]\d{1,2})?$/.test(trimmedValue)) {
        return error;
      }

      const intValue = parseInt(trimmedValue, 10);
      if (min > intValue || max < intValue) {
        return error;
      }

      const floatValue = parseFloat(trimmedValue);
      if (min > floatValue || max < floatValue) {
        return error;
      }

      return null;
    };
  }
}
